import React, { useState } from 'react';

import ForecastOptions from './ForecastOptions';
import ForecastRegionLayer from './ForecastRegionLayer';
import { filterRegionsByAlert, filterFeatureCollectionsById } from '../../utils/forecasts';
import { TIDE_PARAMETER } from '../../utils/constants';
import StationMarker from './StationMarker';

const forecastTypes = ['Marine', 'Tidal'];

const Forecasts = (props) => {
    const {
        tidalBuoys,
        onStationClick,
        setSelectedParameter,
        selectedStation,
        selectedParameter,
        forecasts,
        datasetsMetadata,
        preferredUnitSystem,
        getTotalInteractiveLayers,
        regionsGeoJson,
    } = props;
    const [selectedForecastType, setSelectedForecastType] = useState(forecastTypes[0]);

    const forecastsLoaded = forecasts?.every((query) => query.isSuccess) && regionsGeoJson.isSuccess;

    if (!forecastsLoaded) return null;

    const allForecasts = forecasts?.map((query) => query?.data).flatMap(query => query?.forecasts);

    const onForecastSelect = (e) => {
        if (e === forecastTypes[1]) {
            setSelectedParameter(TIDE_PARAMETER);
        } else {
            setSelectedParameter('');
        }
        setSelectedForecastType(e);
    };

    // Get the IDs of regions with each alert level, then filter them by the previous level
    // For example, if a region has a watch and warning, we only want to render the layer with the warning color
    const warningRegionIds = filterRegionsByAlert(allForecasts, 'warning');
    const advisoryRegionIds = filterRegionsByAlert(allForecasts, 'advisory').filter((id) => !warningRegionIds.includes(id));
    const watchRegionIds = filterRegionsByAlert(allForecasts, 'watch').filter((id) => !advisoryRegionIds.includes(id));
    const noAlertRegionIds = filterRegionsByAlert(allForecasts).filter((id) => !watchRegionIds.includes(id));

    const warningGeojson = filterFeatureCollectionsById(regionsGeoJson.data?.regions, warningRegionIds);
    const advisoryGeojson = filterFeatureCollectionsById(regionsGeoJson.data?.regions, advisoryRegionIds);
    const watchGeojson = filterFeatureCollectionsById(regionsGeoJson.data?.regions, watchRegionIds);
    const noAlertGeojson = filterFeatureCollectionsById(regionsGeoJson.data?.regions, noAlertRegionIds);

    // Gets the total amount of interactive layers necessary to make forecasts selectable
    getTotalInteractiveLayers(warningGeojson.length);

    return (
        <>
            <ForecastOptions forecastTypes={forecastTypes} onForecastSelect={onForecastSelect} />
            {selectedForecastType === forecastTypes[0] && allForecasts?.length > 0 &&
                <>
                    {warningRegionIds.length > 0 && <ForecastRegionLayer geoJson={warningGeojson} severity={'warning'} />}
                    {advisoryRegionIds.length > 0 && <ForecastRegionLayer geoJson={advisoryGeojson} severity={'advisory'} />}
                    {watchRegionIds.length > 0 && <ForecastRegionLayer geoJson={watchGeojson} severity={'watch'} />}
                    {noAlertRegionIds.length > 0 && <ForecastRegionLayer geoJson={noAlertGeojson} />}
                </>
            }
            {selectedForecastType === forecastTypes[1]
                && tidalBuoys?.length > 0
                && tidalBuoys.map((buoy, index) => (
                    <StationMarker
                        key={index}
                        onClick={onStationClick}
                        station={buoy}
                        selectedParameter={selectedParameter}
                        isSelected={selectedStation?.datasetID === buoy.datasetID}
                        showValue={true}
                        datasetsMetadata={datasetsMetadata}
                        preferredUnitSystem={preferredUnitSystem}
                    />
                ))
            }
        </>
    );
};

export default Forecasts;
